// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TradingPositionType;
(function (TradingPositionType) {
    TradingPositionType[TradingPositionType["MultiPosition"] = 0] = "MultiPosition";
    TradingPositionType[TradingPositionType["OnePosition"] = 1] = "OnePosition";
    TradingPositionType[TradingPositionType["MultiPositionPerSide"] = 2] = "MultiPositionPerSide";
    TradingPositionType[TradingPositionType["NotPositionByFIFO"] = 3] = "NotPositionByFIFO";
})(TradingPositionType || (TradingPositionType = {}));
